import React, { Component } from 'react';
import {Link} from 'react-router-dom'
class Footer extends Component {
    render() {
        return (
            <footer id="footer" className="clearfix">
                <div id="footer-widgets" className="container">
                    <div className="themesflat-row gutter-30">
                        <div className="col span_1_of_3">
                            <div className="widget widget_text">
                                <div className="textwidget">
                                    <p>
                                        <img src="assets/img/logo_footer.png" alt="imagealt" width={170} height={34} />
                                    </p>
                                    {/* <p className="margin-bottom-15">We have over 15 years of experien able to help you 24 hours a
                                        day.</p>
                                    <ul>
                                        <li>
                                            <div className="inner">
                                                <span className="fa fa-map-marker" />
                                                <span className="text">PO BOX 16122 COLLINS STREET <span className="sl">West
                                                        Victoria, NewYork</span></span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="inner">
                                                <span className="fa fa-phone" />
                                                <span className="text">CALL US : (+61) 3 8376 6284</span>
                                            </div>
                                        </li>
                                        <li className="margin-top-7">
                                            <div className="inner">
                                                <span className=" font-size-14 fa fa-envelope" />
                                                <span className="text">SUPPORT@NICHE_THEME</span>
                                            </div>
                                        </li>
                                    </ul> */}
                                </div>
                            </div>{/* /.widget_text */}
                            <div className="themesflat-spacer clearfix" data-desktop={0} data-mobile={0} data-smobile={35} />
                        </div>{/* /.col */}
                        
                    </div>
                </div>
            </footer>
        );
    }
}

export default Footer;